import React, { useState } from "react";
import { Dialog, Table } from "../../../layout";
import TableProdWidget from "../../Sales/POS/QuoteSale/ViewQuote/TableProdWidget";
import ViewProd from "../../Catalog/Product/ViewProduct/ViewProd";
import InputReturnQty from "../../Sales/SaleReturn/InputField/InputReturnQty";
import InputReturnReason from "../../Sales/SaleReturn/InputField/InputReturnReason";
import ItemsAmountWidget from "./ItemsAmountWidget";
import InputSellable from "../../Sales/SaleReturn/InputField/InputSellable";

const Items = ({ setValues, sellItems, setSellItems }) => {
  const [showProdDetails, setShowProdDetails] = useState(false);
  const [viewProdId, setViewProdId] = useState();
  const [returnAll, setReturnAll] = useState(false);

  const handleInpChg = (param) => {
    setSellItems([
      ...sellItems.map((j) =>
        j.id === param.id ? { ...j, [param.name]: param.value } : j
      ),
    ]);

    setValues((j) => ({
      ...j,
      returnItems: j.returnItems.map((k) =>
        k.id === param.id ? { ...k, [param.name]: param.value } : k
      ),
    }));
  };

  const handleReturnAll = () => {
    setSellItems((j) =>
      j.map((k) => ({
        ...k,
        returnQty: k.qty,
        discAdj: k.disAmt,
        returnAmt: k.totalPrice,
      }))
    );
    setValues((j) => ({
      ...j,
      returnItems: j.returnItems.map((k) => ({
        ...k,
        returnQty: k.qty,
        discAdj: k.disAmt,
        returnAmt: k.totalPrice,
      })),
    }));
    setReturnAll(true);
  };

  const handleResetQty = () => {
    setSellItems((j) =>
      j.map((k) => ({ ...k, returnQty: "", discAdj: "", returnAmt: "" }))
    );
    setValues((j) => ({
      ...j,
      returnItems: j.returnItems.map((k) => ({
        ...k,
        returnQty: "",
        discAdj: "",
        returnAmt: "",
      })),
    }));
    setReturnAll(false);
  };

  const handleViewProdDetails = (val) => {
    setShowProdDetails(!showProdDetails);
    setViewProdId(val.prodId);
  };

  return (
    <>
      <Table
        ActionComp={() => <></>}
        HeaderComp={() => <></>}
        hideHeader={true}
        showHeader={false}
        showSearch={false}
        tblHead={[
          { id: "serial", label: "#" },
          { id: "prod", label: "Product Details" },
          { id: "sellable", label: "Is Sellable" },
          {
            id: "returnQty",
            label: (
              <div className="flex flex-col leading-5">
                <span>Return Quantity</span>
                {!returnAll ? (
                  <span
                    onClick={handleReturnAll}
                    className="text-[12px] capitalize font-normal underline text-gray-500 cursor-pointer hover:font-semibold w-fit transition-all"
                  >
                    Return All
                  </span>
                ) : (
                  <span
                    onClick={handleResetQty}
                    className="text-[12px] capitalize font-normal underline text-red-500 cursor-pointer hover:font-semibold w-fit transition-all"
                  >
                    Reset Return
                  </span>
                )}
              </div>
            ),
          },
          { id: "reason", label: "Return Reason" },
          { id: "amount", label: "Amount" },
        ]}
        tblData={sellItems.map((item, ind) => {
          return {
            ...item,
            serial: ind + 1,
            sellable: <InputSellable {...{ handleInpChg, item }} />,
            prod: (
              <TableProdWidget
                {...{
                  item,
                  discount: 0,
                  handleView: handleViewProdDetails,
                }}
              />
            ),
            returnQty: (
              <InputReturnQty
                {...{ setSellItems, sellItems, setValues, handleInpChg, item }}
              />
            ),
            reason: <InputReturnReason {...{ handleInpChg, item }} />,
            amount: <ItemsAmountWidget {...{ item }} />,
          };
        })}
      />

      {/* View Product */}
      {showProdDetails && (
        <Dialog show={showProdDetails} onClose={false} maxWidth="lg">
          <ViewProd {...{ setShowForm: setShowProdDetails, id: viewProdId }} />
        </Dialog>
      )}
    </>
  );
};

export default Items;
